import { useState, useEffect, useRef } from 'react'

/**
 * True only after `isActive` has been continuously true for `delayMs`.
 * Resets immediately when `isActive` becomes false (avoids flicker on fast responses).
 */
export function useDelayedLoading(isActive: boolean, delayMs = 2000): boolean {
  const [show, setShow] = useState(false)
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    if (isActive) {
      if (timerRef.current) clearTimeout(timerRef.current)
      timerRef.current = setTimeout(() => {
        timerRef.current = null
        setShow(true)
      }, delayMs)
      return () => {
        if (timerRef.current) {
          clearTimeout(timerRef.current)
          timerRef.current = null
        }
      }
    }
    if (timerRef.current) {
      clearTimeout(timerRef.current)
      timerRef.current = null
    }
    setShow(false)
    return undefined
  }, [isActive, delayMs])

  return show
}
